// extracted by mini-css-extract-plugin
export default {"container":"similar_projects_bar__container__ugybY","link":"similar_projects_bar__link__Laozl","text":"similar_projects_bar__text__bqLlG"};